module.exports = __webpack_public_path__ + "img/q-answered-chart.59596b91.jpg";